import React from "react";

const Footer = () => {
  const u_Data = JSON.parse(localStorage.getItem("user"));
  var d = new Date();
  return (
    <div className={u_Data?.user_type == "Non-ICAI" ? "footer ps-0" : "footer"}>
      <div className="copyright">
        <p>
          Copyright © by <a href="" target="_blank" rel="noreferrer">
            triessence.org
          </a> {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
